import { render, staticRenderFns } from "./TrsTool.vue?vue&type=template&id=3d7e1d3a&"
import script from "./TrsTool.vue?vue&type=script&setup=true&lang=ts&"
export * from "./TrsTool.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports